"use client";
import { Box, HStack } from "@chakra-ui/react";
import { SIDEBAR_CONSTANTS } from "./sidebar.constants";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";

const MobilePricingNav = () => {
  return (
    <Box
      className="scrollbar-hide"
      h="75px"
      overflowX="auto"
      whiteSpace="nowrap"
      py={4}
      bg="white"
      border="1px solid white"
      mx={-3}
      mb={3}
      mt={-4}
      css={{
        scrollSnapType: "x mandatory",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <HStack gap={3} w="max-content">
        {SIDEBAR_CONSTANTS.map((item) =>
          item.options ? (
            item.options.map((option) => (
              <Button
                key={option.value}
                minW="100px"
                variant={"ideal"}
                borderRadius="full"
                onClick={() => scrollToElement(option.value, 180)}
                css={{
                  scrollSnapAlign: "center",
                  display: "inline-flex",
                  justifyContent: "center",
                }}
              >
                {option.label}
              </Button>
            ))
          ) : (
            <Button
              key={item.value}
              minW="120px"
              variant={"ideal"}
              borderRadius="full"
              _hover={{ bg: "blue.50" }}
              onClick={() => scrollToElement(item.value, 180)}
              css={{
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {item.label}
            </Button>
          )
        )}
      </HStack>
    </Box>
  );
};

export default MobilePricingNav;
